<template>
  <div class="menu-area fixed-menu">
    <div class="closes" v-on:click="toggleSidebar('mob')">
      <i class="fa fa-times" aria-hidden="true"></i>
    </div>

    <!-- logo -->
    <div class="logo">
      <a
        @click.prevent="redirectIt('Dashboard')"
        href="/dashboard"
        title="Dashboard"
        data-toggle="tooltip"
      >
        <img
          class="img-fulid small-logo"
          src="../assets/img/logo-g.svg"
          alt="logo"
        />
        <img
          class="img-fulid big-logo"
          src="../assets/img/logo.svg"
          alt="logo"
        />
      </a>
    </div>
    <!-- logo -->
    <ul v-if="this.$storage.get('auth').user.user_type != 0">
      <li
        style="
          background: #fff;
          -o-transition: all 0.4s ease;
          -webkit-transition: all 0.4s ease;
          transition: all 0.4s ease;
        "
        v-if="
          this.$storage.get('auth').user.user_type == 1 ||
          this.$storage.get('auth').user.user_type == 2
        "
      >
        <a href="/message" v-bind:class="this.$route.name == 'message' ? 'active' : ''" title="Messages" data-toggle="tooltip">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 0.9375C5.65082 0.9375 0 5.26758 0 11.1557C0 13.3063 0.76355 15.3426 2.21411 17.0755L0.967529 21.8888C0.782593 22.6025 1.46082 23.2451 2.16595 23.0149L8.52557 20.9392C9.64911 21.2278 10.8164 21.3739 12 21.3739C18.3532 21.3739 24 17.0396 24 11.1557C24 5.22144 18.2926 0.9375 12 0.9375V0.9375ZM12 19.4989C10.8889 19.4989 9.79596 19.3508 8.75189 19.0589C8.57355 19.0091 8.38458 19.0131 8.20844 19.0704L3.21185 20.7014L4.15375 17.0649C4.23358 16.7565 4.15137 16.4286 3.9353 16.1944C2.58746 14.733 1.875 12.9906 1.875 11.1557C1.875 6.55518 6.41711 2.81232 12 2.81232C17.5829 2.81232 22.125 6.55518 22.125 11.1557C22.125 15.7562 17.5829 19.4989 12 19.4989ZM13.1719 11.1555C13.1719 11.8028 12.6473 12.3274 12 12.3274C11.3527 12.3274 10.8281 11.8028 10.8281 11.1555C10.8281 10.5084 11.3527 9.98364 12 9.98364C12.6473 9.98364 13.1719 10.5084 13.1719 11.1555ZM17.8594 11.1555C17.8594 11.8028 17.3348 12.3274 16.6875 12.3274C16.0402 12.3274 15.5156 11.8028 15.5156 11.1555C15.5156 10.5084 16.0402 9.98364 16.6875 9.98364C17.3348 9.98364 17.8594 10.5084 17.8594 11.1555ZM8.48438 11.1555C8.48438 11.8028 7.95978 12.3274 7.3125 12.3274C6.66522 12.3274 6.14062 11.8028 6.14062 11.1555C6.14062 10.5084 6.66522 9.98364 7.3125 9.98364C7.95978 9.98364 8.48438 10.5084 8.48438 11.1555Z"
              fill="#A2A8B8"
            ></path>
          </svg>
          <!-- <img class="img-fluid" src="../assets/img/Lead.svg" alt="">  -->
          <span class="hide-item">Messages</span>
        </a>
        <ul class="sub-menu">
          <li><h4>Messages</h4></li>
          <li>
            <a
              href="/message"
              data-toggle="tooltip"
              v-bind:class="this.$route.name == 'message' ? 'active' : ''"
            >
              Messages
            </a>
          </li>
          <li>
            <a
              href="/chat?tab=chat"
              data-toggle="tooltip"
              v-bind:class="this.$route.name == 'Chat' ? 'active' : ''"
            >
              Inner Circle
            </a>
          </li>
        </ul>
      </li>

      <li
        v-if="
          this.$storage.get('auth').user.user_type == 1 ||
          (this.$storage.get('auth').user.user_type == 2 &&
            this.$storage.get('auth').user.permissions.indexOf('1') != -1)
        "
      >
        <a
          @click.prevent="redirectIt('Leads')"
          href="/leads"
          title="Leadsheets"
          data-toggle="tooltip"
          v-bind:class="this.$route.name == 'Leads' ? 'active' : ''"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <rect opacity="0.01" width="24" height="24" fill="#CDEBFF" />
            <path
              d="M20 8H21C21 7.73478 20.8946 7.48043 20.7071 7.29289L20 8ZM13 1L13.7071 0.292893C13.5196 0.105357 13.2652 0 13 0V1ZM9 17C8.44772 17 8 17.4477 8 18C8 18.5523 8.44772 19 9 19V17ZM15 19C15.5523 19 16 18.5523 16 18C16 17.4477 15.5523 17 15 17V19ZM9 13C8.44772 13 8 13.4477 8 14C8 14.5523 8.44772 15 9 15V13ZM12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13V15ZM3 3V21H5V3H3ZM6 24H18V22H6V24ZM21 21V8H19V21H21ZM20.7071 7.29289L13.7071 0.292893L12.2929 1.70711L19.2929 8.70711L20.7071 7.29289ZM13 0H6V2H13V0ZM12 1V6H14V1H12ZM15 9H20V7H15V9ZM9 19H15V17H9V19ZM9 15H12V13H9V15ZM18 24C19.6569 24 21 22.6569 21 21H19C19 21.5523 18.5523 22 18 22V24ZM3 21C3 22.6569 4.34315 24 6 24V22C5.44772 22 5 21.5523 5 21H3ZM12 6C12 7.65685 13.3431 9 15 9V7C14.4477 7 14 6.55228 14 6H12ZM5 3C5 2.44772 5.44772 2 6 2V0C4.34315 0 3 1.34315 3 3H5Z"
              fill="#A2A8B8"
            />
          </svg>
          <!-- <img class="img-fluid" src="../assets/img/Lead.svg" alt="">  -->
          <span class="hide-item">Leadsheets</span>
        </a>
      </li>

      <li
        v-if="
          this.$storage.get('auth').user.user_type == 1 ||
          (this.$storage.get('auth').user.user_type == 2 &&
            this.$storage.get('auth').user.permissions.indexOf('1') != -1)
        "
      >
        <a
          @click.prevent="redirectIt('appointments')"
          title="Appointments"
          data-toggle="tooltip"
          v-bind:class="this.$route.name == 'appointments' ? 'active' : ''"
        >
          <a href="/appointments">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M7.8 2C7.8 1.55817 7.44183 1.2 7 1.2C6.55817 1.2 6.2 1.55817 6.2 2H7.8ZM17.8 2C17.8 1.55817 17.4418 1.2 17 1.2C16.5582 1.2 16.2 1.55817 16.2 2H17.8ZM4 4.8H7V3.2H4V4.8ZM7 4.8H17V3.2H7V4.8ZM17 4.8H20V3.2H17V4.8ZM20 21.2H4V22.8H20V21.2ZM2.8 20V9H1.2V20H2.8ZM2.8 9V6H1.2V9H2.8ZM21.2 6V9H22.8V6H21.2ZM21.2 9V20H22.8V9H21.2ZM2 9.8H22V8.2H2V9.8ZM7.8 4V2H6.2V4H7.8ZM17.8 4V2H16.2V4H17.8ZM4 21.2C3.33726 21.2 2.8 20.6627 2.8 20H1.2C1.2 21.5464 2.4536 22.8 4 22.8V21.2ZM20 22.8C21.5464 22.8 22.8 21.5464 22.8 20H21.2C21.2 20.6627 20.6627 21.2 20 21.2V22.8ZM20 4.8C20.6627 4.8 21.2 5.33726 21.2 6H22.8C22.8 4.4536 21.5464 3.2 20 3.2V4.8ZM4 3.2C2.4536 3.2 1.2 4.4536 1.2 6H2.8C2.8 5.33726 3.33726 4.8 4 4.8V3.2Z"
                fill="#A2A8B8"
              />
            </svg>
            <span class="hide-item">Appointments</span>
          </a>
        </a>
      </li>

      <li
        v-if="
          this.$storage.get('auth').user.user_type == 1 ||
          (this.$storage.get('auth').user.user_type == 2 &&
            this.$storage.get('auth').user.permissions.indexOf('1') != -1)
        "
      >
        <a
          @click.prevent="redirectIt('tasks')"
          title="Tasks"
          data-toggle="tooltip"
          v-bind:class="this.$route.name == 'tasks' ? 'active' : ''"
        >
          <a href="/tasks">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect opacity="0.01" width="24" height="24" fill="#CDEBFF" />
              <path
                d="M10.7143 4.57153C10.162 4.57153 9.71429 5.01925 9.71429 5.57153C9.71429 6.12382 10.162 6.57153 10.7143 6.57153V4.57153ZM21 6.57153C21.5523 6.57153 22 6.12382 22 5.57153C22 5.01925 21.5523 4.57153 21 4.57153V6.57153ZM10.7143 11.0001C10.162 11.0001 9.71429 11.4478 9.71429 12.0001C9.71429 12.5524 10.162 13.0001 10.7143 13.0001V11.0001ZM21 13.0001C21.5523 13.0001 22 12.5524 22 12.0001C22 11.4478 21.5523 11.0001 21 11.0001V13.0001ZM10.7143 17.4287C10.162 17.4287 9.71429 17.8764 9.71429 18.4287C9.71429 18.981 10.162 19.4287 10.7143 19.4287V17.4287ZM21 19.4287C21.5523 19.4287 22 18.981 22 18.4287C22 17.8764 21.5523 17.4287 21 17.4287V19.4287ZM10.7143 6.57153H21V4.57153H10.7143V6.57153ZM10.7143 13.0001H21V11.0001H10.7143V13.0001ZM10.7143 19.4287H21V17.4287H10.7143V19.4287Z"
                fill="#A2A8B8"
              />
              <circle
                cx="5.57143"
                cy="5.57143"
                r="1.57143"
                stroke="#A2A8B8"
                stroke-width="2"
              />
              <circle
                cx="5.57143"
                cy="11.9999"
                r="1.57143"
                stroke="#A2A8B8"
                stroke-width="2"
              />
              <circle
                cx="5.57143"
                cy="18.4286"
                r="1.57143"
                stroke="#A2A8B8"
                stroke-width="2"
              /></svg
            ><span class="hide-item">Tasks</span>
          </a>
        </a>
      </li>

      <li
        v-if="
          this.$storage.get('auth').user.user_type == 1 ||
          (this.$storage.get('auth').user.user_type == 2 &&
            this.$storage.get('auth').user.permissions.indexOf('1') != -1)
        "
      >
        <a
          @click.prevent="redirectIt('alerts')"
          title="Alerts"
          data-toggle="tooltip"
          v-bind:class="this.$route.name == 'alerts' ? 'active' : ''"
        >
          <a href="/alerts">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M10.285 3.85821L9.59902 3.44662L10.285 3.85821ZM1.8174 17.9709L1.13141 17.5593H1.13141L1.8174 17.9709ZM22.1826 17.9709L22.8686 17.5593L22.1826 17.9709ZM13.715 3.85822L13.029 4.26981V4.26981L13.715 3.85822ZM12.8 8.9999C12.8 8.55808 12.4418 8.1999 12 8.1999C11.5582 8.1999 11.2 8.55808 11.2 8.9999H12.8ZM11.2 12.9999C11.2 13.4417 11.5582 13.7999 12 13.7999C12.4418 13.7999 12.8 13.4417 12.8 12.9999H11.2ZM12.8 15.9999C12.8 15.5581 12.4418 15.1999 12 15.1999C11.5582 15.1999 11.2 15.5581 11.2 15.9999H12.8ZM11.2 16.9999C11.2 17.4417 11.5582 17.7999 12 17.7999C12.4418 17.7999 12.8 17.4417 12.8 16.9999H11.2ZM9.59902 3.44662L1.13141 17.5593L2.50339 18.3825L10.971 4.26981L9.59902 3.44662ZM3.53238 21.7999H20.4676V20.1999H3.53238V21.7999ZM22.8686 17.5593L14.401 3.44662L13.029 4.26981L21.4966 18.3825L22.8686 17.5593ZM11.2 8.9999V12.9999H12.8V8.9999H11.2ZM11.2 15.9999V16.9999H12.8V15.9999H11.2ZM20.4676 21.7999C22.644 21.7999 23.9884 19.4256 22.8686 17.5593L21.4966 18.3825C21.9765 19.1823 21.4004 20.1999 20.4676 20.1999V21.7999ZM1.13141 17.5593C0.0116456 19.4256 1.35596 21.7999 3.53238 21.7999V20.1999C2.59963 20.1999 2.0235 19.1823 2.50339 18.3825L1.13141 17.5593ZM10.971 4.26981C11.4371 3.49301 12.5629 3.49301 13.029 4.26981L14.401 3.44662C13.3135 1.63407 10.6866 1.63407 9.59902 3.44662L10.971 4.26981Z"
                fill="#A2A8B8"
              />
            </svg>
            <span class="hide-item">Alerts</span>
          </a>
        </a>
      </li>

      <li
        v-if="
          this.$storage.get('auth').user.user_type == 1 ||
          (this.$storage.get('auth').user.user_type == 2 &&
            this.$storage.get('auth').user.permissions.indexOf('2') != -1)
        "
      >
        <a
          href="/inventory"
          class="email-icon"
          title="Inventory"
          data-toggle="tooltip"
          v-bind:class="this.$route.name == 'inventory' ? 'active' : ''"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M8.60938 6.99801H12.3889"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.99734 12H5.99609V19.0029"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.99581 19.003H1.99414V7.56019C1.99414 6.87385 2.36639 6.2415 2.96655 5.90851L9.5803 2.23398C10.1511 1.9168 10.8452 1.9168 11.4161 2.23398L18.0298 5.90851C18.6294 6.24192 19.0012 6.87412 19.0012 7.56019V8.99879"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22.003 17.8026C22.003 16.6976 21.1072 15.8018 20.0022 15.8018H11.9989C10.8939 15.8018 9.99805 16.6976 9.99805 17.8026"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.99805 17.8025V21.0038C9.99805 21.5563 10.4459 22.0042 10.9985 22.0042H11.9889C12.5414 22.0042 12.9893 21.5563 12.9893 21.0038V20.3425H19.0118V21.0038C19.0118 21.5563 19.4597 22.0042 20.0122 22.0042H21.0026C21.5551 22.0042 22.003 21.5563 22.003 21.0038V17.8025"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.7378 18.1027H12.2422"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19.7612 18.1027H18.2656"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20.5078 15.7386L22.0034 14.9913"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.4987 15.7386L9.99805 14.9913"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.5674 12C12.873 12.0018 12.2705 12.4797 12.1108 13.1555L11.4766 15.8666L12.1108 13.1555C12.2705 12.4797 12.873 12.0018 13.5674 12H18.4335C19.1279 12.0018 19.7304 12.4797 19.8901 13.1555L20.5243 15.8666"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="hide-item">Inventory </span>
        </a>
      </li>

      <!-- <li v-if="this.$storage.get('auth').user.user_type ==1 || (this.$storage.get('auth').user.user_type == 2 && this.$storage.get('auth').user.permissions.indexOf('2') != -1)">
        <router-link :to="{ name: 'inventory'}" v-bind:class="this.$route.name == 'inventory' ? 'active':''">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M6.59492 1.91998L6.37492 2.54998L3.95492 9.25089H3.67992C2.71923 9.25089 1.91992 10.0831 1.91992 11.0836V18.4145C1.91992 19.4137 2.72078 20.2452 3.67992 20.2473V22.08H5.43992V20.2473H19.5199V22.08H21.2799V20.2473C22.2406 20.2473 23.0399 19.4148 23.0399 18.4145V11.0836C23.0399 10.0831 22.2406 9.25089 21.2799 9.25089H21.0049L18.3649 1.91998H6.59492ZM7.80492 3.75271H17.1549L19.1349 9.25089H5.82492L7.80492 3.75271ZM3.67992 11.0836H21.2799V18.4145H3.67992V11.0836ZM6.86992 12.9163C6.46234 12.9973 6.09533 13.2256 5.83368 13.5609C5.57204 13.8963 5.43258 14.3171 5.43992 14.7491C5.43992 15.2351 5.62535 15.7013 5.95541 16.045C6.28548 16.3887 6.73314 16.5818 7.19992 16.5818C7.6667 16.5818 8.11437 16.3887 8.44443 16.045C8.77449 15.7013 8.95992 15.2351 8.95992 14.7491C8.95992 14.263 8.77449 13.7968 8.44443 13.4531C8.11437 13.1094 7.6667 12.9163 7.19992 12.9163C7.14495 12.9137 7.08989 12.9137 7.03492 12.9163C6.97995 12.9137 6.92489 12.9137 6.86992 12.9163ZM17.4299 12.9163C17.0223 12.9973 16.6553 13.2256 16.3937 13.5609C16.132 13.8963 15.9926 14.3171 15.9999 14.7491C15.9999 15.2351 16.1853 15.7013 16.5154 16.045C16.8455 16.3887 17.2931 16.5818 17.7599 16.5818C18.2267 16.5818 18.6744 16.3887 19.0044 16.045C19.3345 15.7013 19.5199 15.2351 19.5199 14.7491C19.5199 14.263 19.3345 13.7968 19.0044 13.4531C18.6744 13.1094 18.2267 12.9163 17.7599 12.9163C17.705 12.9137 17.6499 12.9137 17.5949 12.9163C17.54 12.9137 17.4849 12.9137 17.4299 12.9163Z" fill="#6D778E"/>
        </svg>
        <span class="hide-item">Inventory </span></router-link>
      </li> -->
      <li
        v-if="
          this.$storage.get('auth').user.user_type == 1 ||
          this.$storage.get('auth').user.permissions.indexOf('3') != -1
        "
      >
        <a
          title="Reports"
          data-toggle="tooltip"
          v-bind:class="this.$route.name == 'Reports' ? 'active' : ''"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 2V1C12.4477 1 12 1.44772 12 2H13ZM22 11V12C22.5523 12 23 11.5523 23 11H22ZM13 11H12C12 11.5523 12.4477 12 13 12V11ZM19 13C19 17.4183 15.4183 21 11 21V23C16.5228 23 21 18.5228 21 13H19ZM11 21C6.58172 21 3 17.4183 3 13H1C1 18.5228 5.47715 23 11 23V21ZM3 13C3 8.58172 6.58172 5 11 5V3C5.47715 3 1 7.47715 1 13H3ZM13 3C17.4183 3 21 6.58172 21 11H23C23 5.47715 18.5228 1 13 1V3ZM12 2V4.22302H14V2H12ZM12 4.22302V11H14V4.22302H12ZM11 5C11.6124 5 12.2076 5.06863 12.7787 5.19823L13.2213 3.24781C12.5059 3.08549 11.7623 3 11 3V5ZM18.8018 11.2213C18.9314 11.7924 19 12.3876 19 13H21C21 12.2377 20.9145 11.4941 20.7522 10.7787L18.8018 11.2213ZM13 12H19.777V10H13V12ZM19.777 12H22V10H19.777V12Z"
              fill="#A2A8B8"
            />
          </svg>
          <span class="hide-item">Reports </span>
        </a>
        <!-- sub-menu -->
        <ul class="sub-menu bigsub">
          <li><h4>Reports</h4></li>
          <li>
            <a
              href="/reports/agents"
              @click.prevent="redirectIt('Reports', 'cate', 'agents')"
              >Agent performance report
            </a>
          </li>
          <li>
            <a
              @click.prevent="redirectIt('Reports', 'cate', 'users')"
              href="/reports/users"
              >Competitive Report</a
            >
          </li>

          <li>
            <a
              @click.prevent="redirectIt('Reports', 'cate', 'leads')"
              href="/reports/leads"
              >Lead report</a
            >
          </li>
          <li>
            <a
              @click.prevent="redirectIt('Reports', 'cate', 'inventory')"
              href="/reports/inventory"
              >Inventory report</a
            >
          </li>
          <li>
            <a
              @click.prevent="redirectIt('Reports', 'cate', 'performanace')"
              href="/reports/performanace"
              >Performance report</a
            >
          </li>
          <li>
            <a
              @click.prevent="
                redirectIt('Reports', 'cate', 'managers-top-down')
              "
              href="/reports/managers-top-down"
              >Managers Top Down report</a
            >
          </li>
          <li>
            <a
              @click.prevent="redirectIt('Reports', 'cate', 'back-into-report')"
              href="/reports/back-into-report"
              >Back into Report</a
            >
          </li>
          <li>
            <a
              @click.prevent="
                redirectIt('Reports', 'cate', 'appointement-by-rap')
              "
              href="/reports/appointement-by-rap"
              >Appointment By Rep</a
            >
          </li>
          <li>
            <a
              @click.prevent="redirectIt('Reports', 'cate', 'sales-rep-report')"
              href="/reports/sales-rep-report"
              >Sales Rep Report</a
            >
          </li>
          <li>
            <a
              @click.prevent="
                redirectIt('Reports', 'cate', 'user-activity-report')
              "
              href="/reports/user-activity-report"
              >User Activity Report</a
            >
          </li>
          <li>
            <a
              @click.prevent="redirectIt('Reports', 'cate', 'lost-report')"
              href="/reports/lost-report"
              >Lost Report</a
            >
          </li>
          <li>
            <a
              @click.prevent="
                redirectIt('Reports', 'cate', 'source-summary-report')
              "
              href="/reports/source-summary-report"
              >Source Summary Report</a
            >
          </li>
          <li>
            <a
              @click.prevent="
                redirectIt('Reports', 'cate', 'dealership-performance-report')
              "
              href="/reports/dealership-performance-report"
              >Dealership Performance Report</a
            >
          </li>
          <li>
            <a
              @click.prevent="redirectIt('Reports', 'cate', 'bdc-report')"
              href="/reports/bdc-report"
              >BDC Report</a
            >
          </li>
          <li>
            <a
              @click.prevent="
                redirectIt('Reports', 'cate', 'response-time-report')
              "
              href="/reports/response-time-report"
              >Response Time Report</a
            >
          </li>
          <li>
            <a
              @click.prevent="
                redirectIt('Reports', 'cate', 'sold-recap-report')
              "
              href="/reports/sold-recap-report"
              >Sold Recap Report</a
            >
          </li>
          <li>
            <a
              @click.prevent="
                redirectIt('Reports', 'cate', 'vehicle-trends-report')
              "
              href="/reports/vehicle-trends-report"
              >Vehicle Trends Report</a
            >
          </li>
          <li>
            <a
              @click.prevent="redirectIt('Reports', 'cate', 'system-report')"
              href="/reports/system-report"
              >System Report</a
            >
          </li>
          <li>
            <a
              @click.prevent="
                redirectIt('Reports', 'cate', 'desking-recap-report')
              "
              href="/reports/desking-recap-report"
              >Desking Recap Report</a
            >
          </li>
          <!-- <li>
            <a
              @click.prevent="redirectIt('Reports', 'cate', 'settings')"
              href="#"
              >Settings</a
            >
          </li> -->
        </ul>
        <!-- sub-menu -->
      </li>

      <li
        v-if="
          this.$storage.get('auth').user.user_type == 1 ||
          this.$storage.get('auth').user.permissions.indexOf('5') != -1
        "
      >
        <a
          @click="checkPermissions(2)"
          title="Marketing"
          data-toggle="tooltip"
          v-bind:class="
            this.$route.name == 'campaignsList' ||
            this.$route.name == 'emailCampaigns'
              ? 'active'
              : ''
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <rect opacity="0.01" width="24" height="24" fill="#CDEBFF" />
            <path
              d="M16.7186 17.7185L16.0115 18.4256L16.7186 17.7185ZM16.7186 2.28132L17.4257 2.98842L17.4257 2.98842L16.7186 2.28132ZM10.3971 19.589L9.42695 19.8316L10.3971 19.589ZM6.63259 20.5303L5.66245 20.7728L6.63259 20.5303ZM8.74113 4.9999H4V6.9999H8.74113V4.9999ZM1 7.9999V11.9999H3V7.9999H1ZM20 16.7735V3.22631H18V16.7735H20ZM16.0115 18.4256C17.4833 19.8975 20 18.855 20 16.7735H18C18 17.0732 17.6376 17.2233 17.4257 17.0114L16.0115 18.4256ZM1 11.9999C1 13.6568 2.34315 14.9999 4 14.9999V12.9999C3.44772 12.9999 3 12.5522 3 11.9999H1ZM4 4.9999C2.34315 4.9999 1 6.34304 1 7.9999H3C3 7.44761 3.44772 6.9999 4 6.9999V4.9999ZM16.0115 1.57421C13.7439 3.84178 11.754 4.9999 8.74113 4.9999V6.9999C12.4626 6.9999 14.9313 5.48279 17.4257 2.98842L16.0115 1.57421ZM17.4257 2.98842C17.6376 2.77649 18 2.92659 18 3.22631H20C20 1.14478 17.4833 0.102343 16.0115 1.57421L17.4257 2.98842ZM19 8.9999H20V6.9999H19V8.9999ZM20 10.9999H19V12.9999H20V10.9999ZM21 9.9999C21 10.5522 20.5523 10.9999 20 10.9999V12.9999C21.6569 12.9999 23 11.6568 23 9.9999H21ZM20 8.9999C20.5523 8.9999 21 9.44761 21 9.9999H23C23 8.34304 21.6569 6.9999 20 6.9999V8.9999ZM4 14.9999H5V12.9999H4V14.9999ZM5 14.9999H8.74113V12.9999H5V14.9999ZM4.02986 14.2424L5.66245 20.7728L7.60274 20.2877L5.97014 13.7574L4.02986 14.2424ZM8.74113 14.9999C8.82133 14.9999 8.90067 15.0007 8.97917 15.0024L9.02083 13.0028C8.92825 13.0009 8.83502 12.9999 8.74113 12.9999V14.9999ZM8.97917 15.0024C11.855 15.0623 13.7991 16.2132 16.0115 18.4256L17.4257 17.0114C14.9992 14.5849 12.5924 13.0772 9.02083 13.0028L8.97917 15.0024ZM11.3672 19.3464L9.97012 13.76L8.02988 14.2452L9.42695 19.8316L11.3672 19.3464ZM8.51485 22.9999C10.4277 22.9999 11.8313 21.2021 11.3672 19.3464L9.42695 19.8316C9.57535 20.425 9.12654 20.9999 8.51485 20.9999V22.9999ZM5.66245 20.7728C5.98967 22.0817 7.1657 22.9999 8.51485 22.9999V20.9999C8.08343 20.9999 7.70737 20.7063 7.60274 20.2877L5.66245 20.7728Z"
              fill="#A2A8B8"
            />
          </svg>
          <span class="hide-item">Marketing </span>
        </a>
        <!-- sub-menu -->
        <ul
          class="sub-menu sub2"
          v-if="
            this.$storage.get('auth').user.dealer_permissions.indexOf('2') != -1
          "
        >
          <li><h4>Marketing</h4></li>
          <li>
            <a href="/campaigns">Email Campaigns</a>
          </li>
          <li>
            <a href="/text-campaign">Text Campaigns</a>
          </li>
          <li>
            <a
              @click.prevent="redirectIt('campaignsList')"
              href="/campaigns-list"
              >Campaigns List</a
            >
          </li>
          <li>
            <a @click.prevent="redirectIt('templates')" href="/templates"
              >Email Templates</a
            >
            <a
              @click.prevent="redirectIt('Sms Templates')"
              href="/sms-templates"
              >Text Templates</a
            >
          </li>
          <li>
            <a href="/videos">Videos</a>
          </li>
        </ul>
        <!-- sub-menu -->
      </li>

      <li
        v-if="
          this.$storage.get('auth').user.user_type == 1 ||
          this.$storage.get('auth').user.permissions.indexOf('4') != -1
        "
      >
        <a
          href="/teams"
          title="Teams"
          data-toggle="tooltip"
          v-bind:class="this.$route.name == 'Members' ? 'active' : ''"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <g clip-path="url(#clip0)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.62353 12.8066C5.88801 12.8066 2.806 15.6305 2.4026 19.2611H16.8364C16.433 15.6305 13.3591 12.8066 9.62353 12.8066ZM12.6652 11.7255C13.94 10.6928 14.6822 9.02269 14.3998 7.20737C14.0771 5.09354 12.3183 3.40731 10.2044 3.1572C7.26765 2.81834 4.78268 5.1016 4.78268 7.96577C4.78268 9.48257 5.4846 10.838 6.58186 11.7255C3.44338 12.8712 1.13591 15.7353 0.797048 19.1804C0.700231 20.1486 1.49897 20.8747 2.37032 20.8747H16.8929C17.7642 20.8747 18.563 20.1566 18.4661 19.1804C18.1112 15.7353 15.8037 12.8712 12.6652 11.7255ZM9.62353 4.73854C7.84048 4.73854 6.3963 6.18273 6.3963 7.96577C6.3963 9.74882 7.84048 11.193 9.62353 11.193C11.4066 11.193 12.8508 9.74882 12.8508 7.96577C12.8508 6.18273 11.3985 4.73854 9.62353 4.73854Z"
                fill="#A2A8B8"
                style="&#10;    fill: #;&#10;"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M23.9932 19.253C24.0819 20.1808 23.3235 20.8747 22.4925 20.8747H20.7579C20.2819 20.8747 19.9188 20.439 20.0156 19.9711C20.0156 19.963 20.0156 19.9549 20.0237 19.9549C20.0882 19.5919 20.3948 19.3337 20.7659 19.3337H22.4522C22.1617 16.7035 20.4029 14.5251 18.0228 13.6215C17.9018 13.5811 17.7969 13.5005 17.7162 13.4036C17.3693 12.9841 16.9901 12.5888 16.5867 12.2257C16.3043 11.9756 16.385 11.5318 16.7238 11.3866C17.8453 10.9267 18.636 9.82947 18.636 8.53051C18.636 7.07826 17.6275 5.86805 16.2801 5.53725C16.2155 5.52112 16.151 5.50498 16.0784 5.49691C15.7718 5.4001 15.5459 5.10158 15.5459 4.75465C15.5459 4.32704 15.9009 3.97205 16.3285 3.97205C16.3769 3.97205 16.4173 3.97205 16.4657 3.98818C16.506 3.99625 16.5463 4.00432 16.5786 4.02045C16.5947 4.02045 16.619 4.02852 16.6351 4.03659C18.5876 4.50454 20.177 6.27145 20.177 8.53051C20.177 9.99084 19.5073 11.2817 18.4665 12.1289C21.4598 13.2261 23.6705 15.9612 23.9932 19.253Z"
                fill="#A2A8B8"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span class="hide-item">Admin </span>
        </a>

        <!-- <a class="active" href="#"><img class="img-fluid" src="../assets/img/friends.svg" alt=""> <span class="hide-item">Team </span></a> -->
        <!-- sub-menu -->
        <!-- <ul class="sub-menu sub2">
          <li><h4>Teams</h4></li>
          <li>
            <a href="/teams">Teams</a>
          </li>
     
        </ul> -->
        <!-- sub-menu -->
      </li>
      <li
        v-if="
          this.$storage.get('auth').user.dealer_permissions.indexOf('4') != -1
        "
      >
        <a
          title="Desking"
          data-toggle="tooltip"
          v-bind:class="
            this.$route.name == 'Desking Setting'
              ? 'email-icon active'
              : 'email-icon'
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewbox="0 0 23 23"
            fill="none"
          >
            <path
              d="M4.09177 10.0531L0.90033 9.94982V19.9703C0.90033 20.9001 1.65126 21.7265 2.49605 21.7265C3.34084 21.7265 4.09177 20.9001 4.09177 19.9703V10.0531ZM4.09177 10.0531V1.06564H17.5146V5.81764"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.515 11.706V20.1769C17.515 21.0034 16.8579 21.7265 16.107 21.7265H2.49646"
              fill="white"
            />
            <path
              d="M17.515 11.706V20.1769C17.515 21.0034 16.8579 21.7265 16.107 21.7265H2.49646"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.7638 12.5324L13.6663 13.0489L14.0417 9.6399L19.2982 3.75156L22.0203 6.64408L16.7638 12.5324Z"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.09589 5.40445H12.8217"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.09589 8.6069H10.0057"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.47113 17.491H7.84659"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.4749 17.491H10.8503"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.4786 17.491H13.854"
              stroke="#A2A8B8"
              stroke-width="1.6"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <span class="hide-item">Desking Log </span>
        </a>
        <!-- sub-menu -->
        <ul class="sub-menu sub2">
          <li><h4>Desking</h4></li>
          <li>
            <a @click.prevent="redirectIt('Desking Log')" href="/desking-log"
              >Desking Log</a
            >
          </li>
          <li>
            <a
              @click.prevent="redirectIt('Desking Setting')"
              href="/desking-setting"
              >Desking Settings</a
            >
          </li>
        </ul>
        <!-- sub-menu -->
      </li>
      <li
        v-if="
          this.$storage.get('auth').user.user_type == 1 ||
          this.$storage.get('auth').user.permissions.indexOf('11') != -1
        "
      >
        <a
          title="Settings"
          data-toggle="tooltip"
          v-bind:class="this.$route.name == 'settings' ? 'active' : ''"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewbox="0 0 24 24"
            fill="none"
          >
            <rect opacity="0.01" width="24" height="24" fill="#CDEBFF" />
            <path
              d="M16.2149 5.19904C16.0733 5.11105 15.9286 5.02736 15.7812 4.94816C15.1279 4.5971 14.6132 4.00052 14.5067 3.2665L14.4119 2.61342C14.2907 1.77864 13.6593 1.09179 12.8181 1.02995C12.548 1.0101 12.2752 1 12.0001 1C11.725 1 11.4523 1.0101 11.1823 1.02994C10.341 1.09177 9.70962 1.77863 9.58844 2.61341L9.49363 3.2665C9.38708 4.00052 8.87245 4.5971 8.21908 4.94816C8.07167 5.02736 7.92704 5.11105 7.78535 5.19904C7.15505 5.5905 6.38085 5.73803 5.69165 5.46321L5.07692 5.21808C4.2944 4.90603 3.38495 5.10828 2.90984 5.80398C2.60226 6.25436 2.32728 6.72878 2.08829 7.22383C1.72194 7.98272 2.00151 8.87186 2.66319 9.39367L3.18541 9.8055C3.76715 10.2643 4.02701 11.0071 4.00406 11.7476C4.00146 11.8314 4.00015 11.9156 4.00015 12C4.00015 12.0844 4.00146 12.1686 4.00406 12.2524C4.02701 12.9929 3.76715 13.7357 3.18541 14.1945L2.66319 14.6063C2.00151 15.1281 1.72194 16.0173 2.08829 16.7762C2.32728 17.2712 2.60226 17.7456 2.90984 18.196C3.38495 18.8917 4.2944 19.094 5.07692 18.7819L5.69165 18.5368C6.38085 18.262 7.15505 18.4095 7.78536 18.801C7.92704 18.8889 8.07167 18.9726 8.21908 19.0518C8.87245 19.4029 9.38708 19.9995 9.49364 20.7335L9.58844 21.3866C9.70963 22.2214 10.341 22.9082 11.1823 22.9701C11.4523 22.9899 11.725 23 12.0001 23C12.2752 23 12.548 22.9899 12.8181 22.97C13.6593 22.9082 14.2907 22.2214 14.4119 21.3866L14.5067 20.7335C14.6132 19.9995 15.1279 19.4029 15.7812 19.0518C15.9286 18.9726 16.0733 18.8889 16.215 18.801C16.8453 18.4095 17.6195 18.262 18.3087 18.5368L18.9233 18.7819C19.7058 19.0939 20.6153 18.8917 21.0904 18.196C21.398 17.7456 21.6729 17.2712 21.9119 16.7761C22.2783 16.0172 21.9987 15.1281 21.337 14.6063L20.8149 14.1945C20.2332 13.7357 19.9733 12.9929 19.9962 12.2524C19.9988 12.1686 20.0002 12.0844 20.0002 12C20.0002 11.9156 19.9988 11.8314 19.9962 11.7476C19.9733 11.0071 20.2332 10.2643 20.8149 9.8055L21.337 9.39374C21.9987 8.87193 22.2783 7.98279 21.9119 7.22391C21.6729 6.72885 21.398 6.25442 21.0904 5.80402C20.6153 5.10832 19.7058 4.90607 18.9233 5.21811L18.3087 5.46321C17.6195 5.73803 16.8453 5.5905 16.2149 5.19904Z"
              stroke="#A2A8B8"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M16 12C16 14.2091 14.2092 16 12 16C9.79087 16 8.00001 14.2091 8.00001 12C8.00001 9.79086 9.79087 8 12 8C14.2092 8 16 9.79086 16 12Z"
              stroke="#A2A8B8"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>

          <span class="hide-item">Settings</span>
        </a>
        <!-- sub-menu -->
        <ul class="sub-menu sub2">
          <li><h4>Settings</h4></li>
          <li>
            <a @click.prevent="redirectIt('settings')" href="/settings"
              >Settings</a
            >
          </li>
          <li>
            <a @click.prevent="redirectIt('LOGINLOGS')" href="/login-logs"
              >Login Log</a
            >
          </li>
          <li>
            <a
              @click.prevent="redirectIt('DeleteleadLogs')"
              href="/delete-lead-logs"
              >Delete Leads Log</a
            >
          </li>
          <li>
            <a @click.prevent="redirectIt('RAWLEADS')" href="/raw-leads"
              >Raw Leads</a
            >
          </li>
           <li>
            <a @click.prevent="redirectIt('notifications')" href="/raw-leads"
              >Notification Settings</a
            >
          </li>
        </ul>
        <!-- sub-menu -->
      </li>
      <li
        v-if="
          this.$storage.get('auth').user.user_type == 1 ||
          this.$storage.get('auth').user.permissions.indexOf('16') != -1
        "
      >
        <a
          @click="checkPermissions(1)"
          href="#"
          title="Tracking"
          data-toggle="tooltip"
          v-bind:class="this.$route.name == 'callHistory' ? 'active' : ''"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M9.30228 20.76C9.42228 20.8622 9.55561 20.9422 9.70228 21.0044C10.0445 21.1422 10.4401 21.0667 10.7378 20.8533C10.9245 20.7156 11.0845 20.5422 11.1956 20.3333C11.3334 20.0622 11.3645 19.7378 11.2534 19.4533C11.1912 19.3111 11.1112 19.1733 11.0089 19.0578C10.9734 19.0178 10.9378 18.9778 10.8978 18.9422C10.8401 18.8889 10.7734 18.8356 10.7067 18.7911C10.6001 18.7244 10.4801 18.6667 10.3601 18.6267C10.2001 18.5911 10.0356 18.5822 9.87561 18.6089C9.44006 18.7111 9.07561 19.04 8.90672 19.4489C8.83117 19.6622 8.81339 19.8933 8.87561 20.1111C8.95117 20.36 9.10672 20.5822 9.30228 20.76ZM9.89339 19.5333C10.0312 19.4933 10.2001 19.48 10.3245 19.5689C10.4267 19.6756 10.4134 19.84 10.3912 19.9733C10.3734 20.0756 10.2801 20.1422 10.1823 20.1467C10.0401 20.1644 9.83561 20.16 9.77783 19.9956C9.74672 19.8444 9.7245 19.6133 9.89339 19.5333Z"
              fill="#A2A8B8"
            />
            <path
              d="M20.7021 8.17778C20.831 6.87556 20.4176 5.62222 19.5332 4.64889C18.8132 3.85778 17.8443 3.34223 16.791 3.15556C16.5021 1.83112 15.3465 0.831116 13.9421 0.831116H6.21762C4.59539 0.831116 3.27539 2.15111 3.27539 3.77334V20.2267C3.27539 21.8489 4.59539 23.1689 6.21762 23.1689H13.9465C15.5687 23.1689 16.8887 21.8489 16.8887 20.2267V12.2356C18.911 11.7867 20.5065 10.1689 20.7021 8.17778ZM4.7865 3.77334C4.7865 2.98223 5.4265 2.34223 6.21762 2.34223H13.9465C14.471 2.34223 14.9154 2.64 15.1643 3.06223H12.9243C11.1465 3.06223 9.58651 3.96 8.70651 5.29334H4.7865V3.77334ZM15.3732 20.2267C15.3732 21.0133 14.7332 21.6578 13.9421 21.6578H6.21762C5.43095 21.6578 4.7865 21.0178 4.7865 20.2267V17.9955H15.3732V20.2267ZM4.7865 16.4844V6.80889H8.07095C8.03095 7 7.98206 7.19111 7.96873 7.39556C7.82206 9.50222 9.1154 11.3911 11.1065 12.0889V14.8133C11.1065 15.1156 11.4576 15.2844 11.6932 15.0889L15.0221 12.3733H15.3776V16.4844H4.7865ZM15.7598 10.8622H14.4798L12.6176 12.3822V10.9111L12.0221 10.7822C10.4354 10.4356 9.36428 9.05778 9.4754 7.50667C9.59095 5.86667 11.1021 4.58222 12.9198 4.58222H15.9287C16.8798 4.58222 17.7865 4.97778 18.4132 5.66667C19.0043 6.32 19.2843 7.16 19.1998 8.03111C19.0443 9.61778 17.5332 10.8622 15.7598 10.8622Z"
              fill="#A2A8B8"
            />
            <path
              d="M16.5154 6.50225C16.5021 6.47113 16.4843 6.43558 16.471 6.40447C16.4532 6.37336 16.4399 6.34225 16.4221 6.31113C16.3687 6.2178 16.3065 6.12447 16.2399 6.04002C16.1732 5.95558 16.1021 5.87558 16.0221 5.80447C15.991 5.77336 15.9554 5.74669 15.9243 5.71558C15.8887 5.68891 15.8576 5.6578 15.8221 5.63113C15.7376 5.56891 15.6532 5.51558 15.5643 5.46669C15.4665 5.41335 15.3687 5.36891 15.2665 5.33335C15.0265 5.24891 14.7687 5.20891 14.5154 5.22669C14.391 5.2578 14.2976 5.36002 14.2621 5.48447C14.2487 5.60891 14.2932 5.74224 14.3954 5.81336C14.511 5.8978 14.6621 5.86224 14.7954 5.88002C14.8976 5.88891 14.9954 5.91113 15.0932 5.94224C15.1954 5.97336 15.2887 6.0178 15.3821 6.07113C15.551 6.16891 15.6976 6.30669 15.8043 6.47114C15.8487 6.54225 15.8887 6.61336 15.9243 6.68891C16.0087 6.88447 16.0399 7.0978 16.0399 7.30669C16.0265 7.46225 16.1332 7.60892 16.2843 7.64447C16.4665 7.69781 16.671 7.55558 16.6843 7.36447C16.7021 7.14669 16.6621 6.92891 16.5999 6.72002C16.5732 6.64447 16.5465 6.57336 16.5154 6.50225Z"
              fill="#A2A8B8"
            />
            <path
              d="M14.258 6.67999C14.3469 6.67555 14.4314 6.67555 14.5202 6.69332C14.6136 6.71555 14.7025 6.74666 14.7869 6.7911C14.8225 6.81332 14.8536 6.83554 14.8847 6.86221C14.9647 6.93332 15.0314 7.02221 15.0802 7.11999C15.1691 7.30221 15.138 7.5111 15.1869 7.70665C15.2447 7.77776 15.3114 7.84887 15.4091 7.86665C15.5202 7.89776 15.6358 7.85332 15.7202 7.78221C15.8314 7.65332 15.8136 7.4711 15.7914 7.3111C15.778 7.22221 15.7514 7.13777 15.7291 7.05332C15.6714 6.91554 15.6047 6.78221 15.5158 6.66221C15.4047 6.51555 15.2758 6.38666 15.1247 6.28444C15.0269 6.21777 14.9202 6.15999 14.8091 6.11999C14.7114 6.08444 14.6091 6.05777 14.5025 6.03999C14.3514 6.01777 14.178 6.00888 14.0536 6.11555C13.9691 6.20888 13.9469 6.33332 13.9647 6.45777C13.9691 6.46666 13.9736 6.47999 13.978 6.48443C14.0402 6.58666 14.138 6.66666 14.258 6.67999Z"
              fill="#A2A8B8"
            />
            <path
              d="M15.4097 8.33334C15.2319 8.15556 15.0319 8.15556 14.8586 8.33334C14.7475 8.44445 14.6363 8.55556 14.5252 8.67112C14.4986 8.70223 14.4719 8.71112 14.4319 8.6889C14.3741 8.65779 14.3119 8.63112 14.2541 8.59556C13.9652 8.42223 13.7119 8.20445 13.4897 7.95112C13.3075 7.75112 13.1386 7.53779 13.0275 7.2889C13.0097 7.24445 13.0097 7.21779 13.0452 7.18223C13.1563 7.07556 13.2675 6.96445 13.3786 6.8489C13.5519 6.67112 13.5563 6.47556 13.3786 6.29779C13.1963 6.11112 13.0141 5.9289 12.8319 5.74668C12.6541 5.5689 12.4586 5.5689 12.2763 5.74668C12.1741 5.8489 12.0719 5.96001 11.9652 6.05334C11.7963 6.20445 11.7341 6.39556 11.743 6.61779C11.7475 6.68445 11.7519 6.74668 11.7652 6.81334C11.823 7.11556 11.9386 7.39112 12.0808 7.65779C12.5563 8.52445 13.2319 9.19556 14.1075 9.65334C14.4097 9.8089 14.7208 9.93334 15.0675 9.96001C15.2675 9.97334 15.4541 9.93779 15.6008 9.79112C15.7297 9.66223 15.8541 9.53779 15.983 9.4089C16.0586 9.33334 16.0986 9.24001 16.0941 9.13334C16.0897 9.03112 16.0363 8.95112 15.9697 8.88001C15.7786 8.70223 15.5963 8.52001 15.4097 8.33334Z"
              fill="#A2A8B8"
            />
          </svg>
          <!-- <img class="img-fluid" src="../assets/img/Lead.svg" alt="">  -->
          <span class="hide-item">Call Tracking</span>
        </a>
        <ul
          class="sub-menu sub2"
          v-if="
            this.$storage.get('auth').user.dealer_permissions.indexOf('1') != -1
          "
        >
          <li><h4>Tracking</h4></li>
          <li>
            <router-link href="/call-history-logs" :to="{ name: 'callHistory' }"
              >Call Tracking</router-link
            >
          </li>
          <li>
            <router-link href="/sms-tracking-logs" :to="{ name: 'smsHistory' }"
              >Text Tracking</router-link
            >
          </li>

          <li>
            <router-link href="/call-settings" :to="{ name: 'callSettings' }"
              >Tracking Settings</router-link
            >
          </li>
        </ul>
      </li>
    </ul>
    <ul v-if="this.$storage.get('auth').user.user_type == 0">
      <li>
        <router-link
          title="Dealers"
          data-toggle="tooltip"
          :to="{ name: 'Dealers' }"
          v-bind:class="this.$route.name == 'Dealers' ? 'active' : ''"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <rect opacity="0.01" width="24" height="24" fill="#CDEBFF" />
            <path
              d="M10.7143 4.57153C10.162 4.57153 9.71429 5.01925 9.71429 5.57153C9.71429 6.12382 10.162 6.57153 10.7143 6.57153V4.57153ZM21 6.57153C21.5523 6.57153 22 6.12382 22 5.57153C22 5.01925 21.5523 4.57153 21 4.57153V6.57153ZM10.7143 11.0001C10.162 11.0001 9.71429 11.4478 9.71429 12.0001C9.71429 12.5524 10.162 13.0001 10.7143 13.0001V11.0001ZM21 13.0001C21.5523 13.0001 22 12.5524 22 12.0001C22 11.4478 21.5523 11.0001 21 11.0001V13.0001ZM10.7143 17.4287C10.162 17.4287 9.71429 17.8764 9.71429 18.4287C9.71429 18.981 10.162 19.4287 10.7143 19.4287V17.4287ZM21 19.4287C21.5523 19.4287 22 18.981 22 18.4287C22 17.8764 21.5523 17.4287 21 17.4287V19.4287ZM10.7143 6.57153H21V4.57153H10.7143V6.57153ZM10.7143 13.0001H21V11.0001H10.7143V13.0001ZM10.7143 19.4287H21V17.4287H10.7143V19.4287Z"
              fill="#A2A8B8"
            />
            <circle
              cx="5.57143"
              cy="5.57143"
              r="1.57143"
              stroke="#A2A8B8"
              stroke-width="2"
            />
            <circle
              cx="5.57143"
              cy="11.9999"
              r="1.57143"
              stroke="#A2A8B8"
              stroke-width="2"
            />
            <circle
              cx="5.57143"
              cy="18.4286"
              r="1.57143"
              stroke="#A2A8B8"
              stroke-width="2"
            />
          </svg>
          <span class="hide-item">Dealers </span>
        </router-link>
      </li>

      <!-- <li>
        <router-link :to="{ name: 'Managers'}" v-bind:class="this.$route.name == 'Managers' ? 'active':''">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clip-path="url(#clip0)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.62353 12.8066C5.88801 12.8066 2.806 15.6305 2.4026 19.2611H16.8364C16.433 15.6305 13.3591 12.8066 9.62353 12.8066ZM12.6652 11.7255C13.94 10.6928 14.6822 9.02269 14.3998 7.20737C14.0771 5.09354 12.3183 3.40731 10.2044 3.1572C7.26765 2.81834 4.78268 5.1016 4.78268 7.96577C4.78268 9.48257 5.4846 10.838 6.58186 11.7255C3.44338 12.8712 1.13591 15.7353 0.797048 19.1804C0.700231 20.1486 1.49897 20.8747 2.37032 20.8747H16.8929C17.7642 20.8747 18.563 20.1566 18.4661 19.1804C18.1112 15.7353 15.8037 12.8712 12.6652 11.7255ZM9.62353 4.73854C7.84048 4.73854 6.3963 6.18273 6.3963 7.96577C6.3963 9.74882 7.84048 11.193 9.62353 11.193C11.4066 11.193 12.8508 9.74882 12.8508 7.96577C12.8508 6.18273 11.3985 4.73854 9.62353 4.73854Z" fill="#A2A8B8" style="&#10;    fill: #;&#10;"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.9932 19.253C24.0819 20.1808 23.3235 20.8747 22.4925 20.8747H20.7579C20.2819 20.8747 19.9188 20.439 20.0156 19.9711C20.0156 19.963 20.0156 19.9549 20.0237 19.9549C20.0882 19.5919 20.3948 19.3337 20.7659 19.3337H22.4522C22.1617 16.7035 20.4029 14.5251 18.0228 13.6215C17.9018 13.5811 17.7969 13.5005 17.7162 13.4036C17.3693 12.9841 16.9901 12.5888 16.5867 12.2257C16.3043 11.9756 16.385 11.5318 16.7238 11.3866C17.8453 10.9267 18.636 9.82947 18.636 8.53051C18.636 7.07826 17.6275 5.86805 16.2801 5.53725C16.2155 5.52112 16.151 5.50498 16.0784 5.49691C15.7718 5.4001 15.5459 5.10158 15.5459 4.75465C15.5459 4.32704 15.9009 3.97205 16.3285 3.97205C16.3769 3.97205 16.4173 3.97205 16.4657 3.98818C16.506 3.99625 16.5463 4.00432 16.5786 4.02045C16.5947 4.02045 16.619 4.02852 16.6351 4.03659C18.5876 4.50454 20.177 6.27145 20.177 8.53051C20.177 9.99084 19.5073 11.2817 18.4665 12.1289C21.4598 13.2261 23.6705 15.9612 23.9932 19.253Z" fill="#A2A8B8"/>
            </g>
            <defs>
            <clipPath id="clip0">
            <rect width="24" height="24" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            <span class="hide-item">Managers </span>
        </router-link>
      </li> -->
    </ul>
    <div
      class="modal fade"
      id="attention"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Attention</h5>
            <a class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"
                ><img
                  class="img-fluid"
                  src="../assets/img/23. Closex.svg"
                  alt=""
              /></span>
            </a>
          </div>

          <div class="modal-body">
            <p style="margin-bottom: 20px">
              Please Contact
              <span style="font-weight: 700; color: #3151a1">DealersGear</span>
              To Activate This Feature
            </p>
            <p style="margin-bottom: 5px">
              <span style="font-weight: 700; color: black">Email : </span
              ><a style="color: #3151a1" href="mailto:support@dealersgear.com"
                >support@dealersgear.com</a
              >
            </p>
            <p>
              <span style="font-weight: 700; color: black">Phone : </span>
              <span style="color: #3151a1">949-923-0190</span>
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="rem-btn close"
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
export default {
  name: "TheSidebar",
  data() {
    return {
      teams: [],
    };
  },
  created() {
    if (this.$storage.get("auth").user.user_type != 0) {
      this.getTeams();
    }

    this.$root.$on("action", function (action) {
      if (action == "openattentionmodal") {
        $("#attention").modal("show");
        $("#attention").appendTo("body");
      }
    });
  },
  methods: {
    checkPermissions(type) {
      if (
        type == 2 &&
        this.$storage.get("auth").user.dealer_permissions.includes("2") == false
      ) {
        $("#attention").modal("show");
        $("#attention").appendTo("body");
      }
      if (
        type == 3 &&
        this.$storage.get("auth").user.dealer_permissions.includes("3") == false
      ) {
        $("#attention").modal("show");
        $("#attention").appendTo("body");
      }
      if (
        type == 1 &&
        this.$storage.get("auth").user.dealer_permissions.includes("1") == false
      ) {
        $("#attention").modal("show");
        $("#attention").appendTo("body");
      }
    },
    openTeamModal() {
      this.$root.$emit("action", "openteamodal");
    },
    redirectIt(route, key = "", value = "") {
      localStorage.removeItem('DataTables_leads_table_/leads');
      localStorage.removeItem('DataTables_appt_table_/appointments');
      localStorage.removeItem('DataTables_tasks_table_/tasks');
      localStorage.removeItem('DataTables_alerts_table_/alerts');
      localStorage.removeItem('DataTables_alerts_table_/leads');

      if (this.$route.name == route) {
        if (key != "") {
          if (value == this.$route.params.cate) {
            this.$router.go();
          } else {
            this.$router.push({ name: route, params: { cate: value } });
          }
        } else {
          this.$router.go();
        }
      } else {
        if (key != "") {
          this.$router.push({ name: route, params: { cate: value } });
        } else {
          this.$router.push({ name: route });
        }
      }
    },
    toggleSidebar(where) {
      if (where == "web") {
        $(".menu-area").toggleClass("menu-full");
        $(".hide-item").toggleClass("show-item");
        $(".big-logo").toggleClass("show-logo");
        $(".audits-completed").toggleClass("menu-full-body");
      } else if (where == "mob") {
        $(".menu-area").toggleClass("mobile");
        $(".audits-completed").removeClass("menu-full-body");
        $(".menu-area").removeClass("menu-full");
        $(".hide-item").removeClass("show-item");
        $(".big-logo").removeClass("show-logo");
      }
    },
    getTeams() {
      axios
        .get("teams", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
            "X-Requested-With": "XMLHttpRequest",
          },
        })
        .then((res) => {
          const {
            data: { data },
          } = res;
          this.teams = data;
          this.$root.$on("newTeam", function (newTeam_data) {
            data.push(newTeam_data);
          });
          //console.log(res)
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    $(".closes").click(function () {
      $(".menu-area").removeClass("mobile");

      return false;
    });

    $(".menu-area ul li").click(function () {
      $(this).find(".sub-menu").toggleClass("submenu");
    });
  },
};
</script>
<style scoped>
.menu-area ul li a{
  height: 46px;
}
</style>
